// ----------------------------------------------------------------------

export function getRequestBody(request) {
    if (!request) return undefined;

    const _request = JSON.parse(JSON.stringify(request));
    if (_request?.keyword) {
        _request[_request.search_category] = _request.keyword;

        delete _request.keyword;
        delete _request.search_category;
    }

    if (_request?.shipment_status === "PURCHASED") {
        _request.shipment_status_list = "PURCHASED,EXPIRED,EXPIRE_FAILED";

        delete _request.shipment_status;
    }

    if (_request?.start_day) {
        _request.search_start_date = _request.start_day;
        delete _request.start_day;
    }

    if (_request?.end_day) {
        _request.search_end_date = _request.end_day;
        delete _request.end_day;
    }

    delete _request.total;

    return _request;
}
